const EmptyAsset = ({ title, desc, iconAsset }) => {
    return (
        <div className="flex flex-col w-full items-center gap-2 py-24">
            <img src={iconAsset || "/asset/icon/empty_asset.svg"} className="w-[64px] mb-3" />
            <p className="text-[14px] font-normal text-[#1E3A8A]">{title}</p>
            <p className="text-[14px] font-normal text-[#1E3A8A]">{desc}</p>
        </div>
    )
}

export default EmptyAsset;